import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledTagCloseButton } from '../../components/TagCloseButton/TagCloseButton.styles';
import { marginMixin } from '../marginMixin';
import { typographyMixin } from '../typographyMixin';
export var TagMixin = function TagMixin(props) {
  var appearance = props.appearance,
    size = props.size,
    textTransform = props.textTransform;
  return token({
    backgroundColor: "Tag.colors." + appearance + ".background",
    borderRadius: 'Tag.borderRadius',
    color: "Tag.colors." + appearance + ".fontColor",
    focusShadow: 'Tag.boxShadow.focus',
    fontType: "Tag.fontTypes." + size,
    horizontalPadding: "Tag.horizontalPadding." + size,
    targetPadding: 'Tag.targetPadding',
    verticalPadding: 'Tag.verticalPadding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      color = _ref.color,
      focusShadow = _ref.focusShadow,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      targetPadding = _ref.targetPadding,
      verticalPadding = _ref.verticalPadding;
    return css(["", " display:inline-flex;align-items:center;vertical-align:top;border-radius:", "px;padding:", "px ", "px;text-transform:", ";background-color:", ";&,", "{color:", ";}", "{margin-left:", "px;", "{box-shadow:none;}}&:focus-within{box-shadow:", ";}& > ", "{display:inline-block;margin-right:", "px;}", ""], typographyMixin(Object.assign({}, props, {
      fontType: fontType,
      fontTypeIconAlignment: false
    })), borderRadius, verticalPadding, horizontalPadding, textTransform, backgroundColor, StyledTagCloseButton, color, StyledTagCloseButton, horizontalPadding / 2 - targetPadding, StyledIcon, focusShadow, StyledIcon, horizontalPadding / 2, marginMixin(Object.assign({}, props)));
  })(props);
};